import React from "react";
import loaderImage from "../../assets/loader.gif";
import loaderImageBlack from "../../assets/loader-black.gif";


function LoadingScreen({ size = 60, loaderType = "default"}) {
  return (
    <div className="flex items-center justify-center h-full w-full">
      <img src={loaderType==="black" ? loaderImageBlack :loaderImage} alt="Swan logo" className={`w-[${size}px]`} width={size} />
    </div>
  );
}

export default LoadingScreen;
